
define( 'FORCES_AND_MOTION_BASICS/../nls/tr/forces-and-motion-basics-strings',{
          "none": "Az",
          "force": "Kuvvet",
          "values": "Kuvvetlerin Büyüklüklerini Göster",
          "frictionTitle": "Sürtünme",
          "redWins": "Kırmızı takım kazandı!",
          "frictionForce": "Sürtünme Kuvveti",
          "pause": "Duraklat",
          "friction": "Sürtünme Kuvveti",
          "accelerationLab": "İvme",
          "forces-and-motion-basics.name": "Kuvvet ve Hareket: Temel Prensipler",
          "appliedForce": "Uygulanan Kuvvet",
          "leftForce": "Sol Kuvvet",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "Sağ Kuvvet",
          "acceleration": "İvme",
          "sound": "Ses",
          "lots": "Çok",
          "forces": "Kuvvetler",
          "motion": "Hareket",
          "tugOfWar": "Halat Çekme Oyunu",
          "go": "Başla!",
          "newtons.n": "Newtons (N)",
          "sumOfForcesEqualsZero": "Net Kuvvet = 0",
          "blueWins": "Mavi takım kazandı!",
          "speed": "Hız",
          "sumOfForces": "Net Kuvvet",
          "return": "Yeniden başla",
          "translation.credits": "Serkan Duman, Kemal Berktan Ortaokulu, fenoloji@hotmail.com",
          "newtons": "Newtons",
          "masses": "Kütleleri Göster",
          "forceReadout.pattern": "{0}N"
        } );